// GENERATED CODE - DO NOT MODIFY BY HAND

import * as m from '@april9au/stack9-sdk';
import { z } from 'zod';

import { HealthQuestion } from './HealthQuestion';

export const FormTypeOptionSet = [
  'Mental Health Screen',
  'Mental Health Rescreen',
  'Physical Health Screen',
  'Physical Health Rescreen',
  'Clinic Form',
] as const;
export const FormTypeOptionType = z.enum(FormTypeOptionSet);
export type FormTypeOptionType = z.infer<typeof FormTypeOptionType>;

export const OverallRatingOptionSet = ['Green', 'Amber', 'Red'] as const;
export const OverallRatingOptionType = z.enum(OverallRatingOptionSet);
export type OverallRatingOptionType = z.infer<typeof OverallRatingOptionType>;

export const DepressionRatingOptionSet = ['Green', 'Amber', 'Red'] as const;
export const DepressionRatingOptionType = z.enum(DepressionRatingOptionSet);
export type DepressionRatingOptionType = z.infer<
  typeof DepressionRatingOptionType
>;

export const AnxietyRatingOptionSet = ['Green', 'Amber', 'Red'] as const;
export const AnxietyRatingOptionType = z.enum(AnxietyRatingOptionSet);
export type AnxietyRatingOptionType = z.infer<typeof AnxietyRatingOptionType>;

export const StressRatingOptionSet = ['Green', 'Amber', 'Red'] as const;
export const StressRatingOptionType = z.enum(StressRatingOptionSet);
export type StressRatingOptionType = z.infer<typeof StressRatingOptionType>;

export const HealthScreen = z.object({
  form_type: FormTypeOptionType,
  client_id: m.ZSingleDropDown,
  practitioner: m.ZTextField.optional().nullable(),
  form_definition: m.ZMonacoEditorField,
  form_response: m.ZMonacoEditorField.optional().nullable(),
  overall_score: m.ZNumericField.optional().nullable(),
  overall_rating: OverallRatingOptionType.optional().nullable(),
  depression_score: m.ZNumericField.optional().nullable(),
  depression_rating: DepressionRatingOptionType.optional().nullable(),
  anxiety_score: m.ZNumericField.optional().nullable(),
  anxiety_rating: AnxietyRatingOptionType.optional().nullable(),
  stress_score: m.ZNumericField.optional().nullable(),
  stress_rating: StressRatingOptionType.optional().nullable(),
  screening_dt: m.ZDateField,
  notes: m.ZRichTextEditor.optional().nullable(),
  follow_up_required: m.ZCheckbox.optional().nullable(),
  follow_up_dt: m.ZDateField.optional().nullable(),
  follow_up_notes: m.ZRichTextEditor.optional().nullable(),
  first_name: m.ZTextField.optional().nullable(),
  last_name: m.ZTextField.optional().nullable(),
  email_address: m.ZTextField.optional().nullable(),
  agency: m.ZTextField.optional().nullable(),
  command: m.ZTextField.optional().nullable(),
  reminder_dt: m.ZDateField.optional().nullable(),
  phone: m.ZTextField.optional().nullable(),
  gender: m.ZTextField.optional().nullable(),
  dob: m.ZDateField.optional().nullable(),
  original_screen_id: m.ZSingleDropDown.optional().nullable(),
  is_rescreen: m.ZCheckbox.optional().nullable(),
  rescreen_token: m.ZTextField.optional().nullable(),
  department: m.ZTextField.optional().nullable(),
  coaching_opt_in: m.ZCheckbox.optional().nullable(),
});
export type HealthScreen = z.infer<typeof HealthScreen>;

export const HealthScreenWithRelated = HealthScreen.extend({
  questions: z.array(HealthQuestion),
});
export type HealthScreenWithRelated = z.infer<typeof HealthScreenWithRelated>;

export const DBHealthScreen = m.ZEntityWorkflowInterface.merge(
  m.ZEntityInterface.merge(HealthScreen),
);
export type DBHealthScreen = z.infer<typeof DBHealthScreen>;
